import { PassengerBookingView } from '@mopla/data-models';

/** Fee charged on cancellation, 0 when none. Supersedes the per-leg `costOfCancellation`. */
export const getChargedCancellationFeeCents = (
	booking: PassengerBookingView
): number =>
	(booking.overwritingPriceInfoAggregate ?? booking.originalPriceInfoAggregate)
		?.totalChargedCancellationFeeCents ?? 0;
